import { SxProps, Theme } from '@mui/material';

export const styledAccordionDetailsSx: SxProps<Theme> = (theme) => ({
	padding: 0,
	'&.shipment-group-details': {
		padding: 0,
		background: theme.palette.background.default,
		borderTop: `1px solid  ${theme.palette.divider}`,
	},

	'.header-menu &.MuiAccordionDetails-root': {
		display: 'block',
		paddingTop: 0,
	},
});
